import Axios from "axios";

const tablesForSelect = {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    actions: {
        async loadList ({ state, commit }) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/tables',
                method: 'GET',
            }).then(resp => {
                let tablesForSelect = resp.data.items.map(({name, tableId, gameType, isVirtualTable}) => {
                    return {
                        label: name,
                        value: tableId.toString(),
                        gameType: gameType,
                        isVirtualTable: isVirtualTable || false,
                    };
                })
                commit('SET_LIST', tablesForSelect);
                commit('SET_LOADED', true);
                commit('SET_PROMISE', null);
            });

            commit('SET_PROMISE', promise);

            return promise;
        },
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    getters: {
        list: (state) => state.list,
        getTable: (state) => (tableId) => {
            return state.list.find(option => option.value == tableId)
        },
        getName: (state) => (tableId) => {
            let table = state.list.find(option => option.value == tableId)
            return table ? table.label : tableId
        },
        loaded: (state) => state.loaded,
    }
};

export default tablesForSelect;
